import { RouteObject } from "react-router-dom";
import HomePage from "@/pages/home/page";
import ServicesPage from "@/pages/services/page";
import AboutPage from "@/pages/about/page";
import PortfolioPage from "@/pages/portfolio/page";
import ContactPage from "@/pages/contact/page";
import AcademyPage from "@/pages/academy/page";
import CourseDetail from "@/pages/academy/components/CourseDetail";
import NotFound from "@/pages/NotFound";
import AIReadinessPage from "@/pages/ai-readiness/page";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/portfolio", element: <PortfolioPage /> },
  { path: "/academy", element: <AcademyPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/ai-readiness", element: <AIReadinessPage /> },
  { path: "/academy/:slug", element: <CourseDetail /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
